import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, finalize } from 'rxjs/operators';
import { IResponseDslrStart } from 'src/app/shared/interfaces/interface';
import { StorageKey } from 'src/app/shared/constants/global-config.constant';
import { getHttpRetryOperator } from 'src/app/shared/utils/http-retry.util';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root'
})
export class DataDslrService {

  constructor(
    private httpClient: HttpClient,
    private commonService: CommonService
  ) { }

  checkDslrBoothConfig(): boolean {
    if(
      !localStorage.getItem(StorageKey.DSLRBOOTH_ENDPOINT) || 
      !localStorage.getItem(StorageKey.DSLRBOOTH_PASSWORD) || 
      !localStorage.getItem(StorageKey.DSLRBOOTH_PORT)) {
      return false;
    }
    else {
      return true;
    }
  }

  startDslrCountdown(mode: string = 'print'): Observable<IResponseDslrStart> {
    const dslrEndpoint = localStorage.getItem(StorageKey.DSLRBOOTH_ENDPOINT);
    const dslrPassword = localStorage.getItem(StorageKey.DSLRBOOTH_PASSWORD);
    const dslrPort = localStorage.getItem(StorageKey.DSLRBOOTH_PORT);
    
    console.log('[DSLR] Starting DSLR countdown request...');
    
    return this.httpClient.get<IResponseDslrStart>(`${dslrEndpoint}:${dslrPort}/api/start?mode=print&password=${dslrPassword}`)
      .pipe(
        tap((response) => {
          console.log('[DSLR] Request successful', response);
        }),
        getHttpRetryOperator({
          maxRetries: 3,
          delayMs: 5000,
          logPrefix: '[DSLR]',
          onRetry: (current, max) => this.commonService.showRetryToast(current, max)
        }) as any,
        finalize(() => {
          console.log('[DSLR] Request attempt completed');
        })
      );
  }

}
